import { ODataV4Adaptor } from '@syncfusion/ej2-data';

export default class MeetingCustomAdapter extends ODataV4Adaptor {
  processResponse () {
    let i = 0;
    let original = super.processResponse.apply(this, arguments);
    let offset = new Date().getTimezoneOffset();
    original.forEach(function (item) {
      let roomIds = [];
      item['roomIds'].forEach(elem => roomIds.push(elem._id));
      // if (item.type === 'video') {
      //   item['roomIds'].forEach(elem => roomIds.push(elem.roomId));
      // } else {
      //   if (item['roomIds'][0] !== undefined) {
      //     roomIds.push(item['roomIds'][0]._id);
      //   }
      // }
      item['roomIds'] = roomIds;
      item['startDtime'] = new Date(new Date(item['startDtime']).getTime() + (-1 * offset * 60 * 1000));
      item['endDtime'] = new Date(new Date(item['endDtime']).getTime() + (-1 * offset * 60 * 1000));
      item['attendeesList'] = item['attendees'].length < 1 ? '참여자 없음' : item['attendees'].map(e => e.username).join(', ');
      if (item.repeatInfo) {
        item['recurrenceRule'] = item.repeatInfo.ruleOutput;
      }
    });
    return original;
  }
}



// WEBPACK FOOTER //
// ./src/components/schedules/MeetingCustomAdapter.js